const validate = (password) => {
  const re = new RegExp('^.*(?=.{8,})(?=.*[a-z])(?=.*[A-Z])(?=.*[\\d\\w]).*$'); // eslint-disable-line
  return re.test(password);
};

export default validate;
